import React from 'react';
import cn from 'classnames';
import {Carousel, SearchDocs} from '../../../components';
import {EXTRA_BLOCKS} from '../extra_information';
import {useIsMobile} from '../../../hooks';
import {handleClickToLink, triggerYaEvent} from '../../../utils/yandex_counter';
import photo from '../images/photo.png';
import photo2x from '../images/photo@2x.png';
import './welcome.scss';

function Welcome() {
    const isSlider = useIsMobile();
    const extra = EXTRA_BLOCKS.map(({text, img, link}) => {
        return (
            <div className="welcome__extrainfo" key={img}>
                <div className={cn('welcome__extraimg', img)}/>
                <div className="welcome__extratext">
                    {link ? (
                        <a href={link} onClick={handleClickToLink}>
                            {text}
                        </a>
                    ) : (
                        text
                    )}
                </div>
            </div>
        );
    });
    return (
        <div className="welcome">
            <div className="welcome__header">Проверьте подлинность документов жилищного учета</div>
            <SearchDocs
                onFocus={() => triggerYaEvent('Клик на поле Идентификатор документа')}
                onSearch={() => triggerYaEvent('Клик по кнопке Проверить')}
            />
            {!isSlider && <div className="welcome__extra">{extra}</div>}
            {isSlider && (
                <div className="welcome__extraslider">
                    <Carousel dotsClass="welcome__extradots">
                        {extra.map((el, index) => (
                            <div key={index}>{el}</div>
                        ))}
                    </Carousel>
                </div>
            )}
            <img src={photo} alt="" srcSet={`${photo2x} 2x`} className="welcome__background"/>
        </div>
    );
}

export {Welcome};
